import * as React from "react";

const SvgComponent = ({ bgcolor, border, color, width = "31px", height = "30px" }) => (
  <svg width={width} height={height} fill="none">
    <rect
      x={0.701}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      fill={bgcolor}
      stroke={border}
      viewBox="0 0 31 30"
    />
    <path
      d="m13.358 13.391.253-.149.524 1.153.896-1.45-1.758-2.92-2.687-4.517c-.118-.205-.389-.279-.575-.149-.574.372-.811 1.134-.574 1.804l1.943 5.466c.288.873 1.234 1.227 1.978.762ZM16.637 15.623l-.963 2.175 1.994 4.425c.304.67 1.048.93 1.64.558l.101-.075c.592-.372.778-1.227.389-1.84l-3.16-5.243Z"
      fill={color}
    />
    <path
      d="M21.268 6.883c-.17-.167-.423-.111-.541.093 0 0-1.521 2.77-1.96 3.551-.068.112-.203.15-.305.093-.101-.074-.152-.223-.084-.334l1.808-3.644a.41.41 0 0 0-.203-.558c-.152-.056-.32.018-.405.167l-1.961 3.551c-.068.112-.203.15-.304.093-.102-.074-.152-.223-.085-.334l1.809-3.644a.41.41 0 0 0-.203-.558c-.152-.056-.321.018-.406.167L16.35 9.282l-.253.502c-.27.502-.355 1.097-.237 1.561l.254 1.004-5.223 8.497c-.372.632-.203 1.469.389 1.84l.101.075c.592.372 1.352.13 1.64-.558l4.073-9.221.913-.26c.44-.131.845-.503 1.115-1.005l.254-.502 1.91-3.848c.135-.168.118-.372-.017-.484Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;